import React from 'react'
import { Datepicker } from "@datepicker-react/styled";

const DateRangePicker = ({ dateRange, handleDatesChange }) => {

    return (
        ({ dateRange } &&
            <Datepicker
                onDatesChange={handleDatesChange}
                startDate={dateRange.startDate} // Date or null
                endDate={dateRange.endDate} // Date or null
                focusedInput={dateRange.focusedInput} // START_DATE, END_DATE or null
                showResetDates={false}
                showSelectedDates={false}
                showClose={false}
            />
        ))
}
export default DateRangePicker